export type ValuationRequestOptions = RequestInit;

export const fetchValuationRequest = async (
  url: string,
  options: ValuationRequestOptions = {}
): Promise<Response> => {
  return fetch(url, options);
};
